

import {
  CHANGE_PAGE,
  LOAD_WORD_VERBATIMS_ERROR, LOAD_WORD_VERBATIMS_REQUEST, LOAD_WORD_VERBATIMS_SUCCESS, RADIO_SELECT, RESET_RADIO,
  SET_WORD
} from "./word-verbatims-action-types";

export const setWord = word => ({ type: SET_WORD, word });

export const loadWordVerbatimsRequest = word => ({ type: LOAD_WORD_VERBATIMS_REQUEST, word });
export const loadWordVerbatimsSuccess = ({ general, negation }) => (
  { type: LOAD_WORD_VERBATIMS_SUCCESS, general, negation}
  );
export const loadWordVerbatimsError = error => ({ type: LOAD_WORD_VERBATIMS_ERROR, error });

export const radioSelect = selectedRadio => ({ type: RADIO_SELECT, selectedRadio });

export const changePage = ({ page, general, negation, next, previous }) => (
  { type: CHANGE_PAGE, page, general, negation, next, previous }
  );

export const resetRadio = () => ({ type: RESET_RADIO });


// WEBPACK FOOTER //
// ./src/modules/word-verbatims/word-verbatims-action-creators.js